import { render } from "./AdminLayout.vue?vue&type=template&id=62c698f8"
import script from "./AdminLayout.vue?vue&type=script&lang=js"
export * from "./AdminLayout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Trinity_Projects\\cesp_skuuni_admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__